import { MasterService } from '../services/master.service';
import config from "../config";
const {
  apiGateway: { AUTH_APPCORE,AUTH_BASE },
} = config;
export const loginUser = async (data) => {
  try {
    return MasterService.post(`${AUTH_APPCORE}/login-user`, data);
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (data) => {
  try {
    return MasterService.post(`${AUTH_APPCORE}/sendemail`, data);
  } catch (error) {
    throw error;
  }
};

export const validateForgotPasswordToken = async (data) => {
  try {
    return MasterService.post(`${AUTH_APPCORE}/verifyresettoken`, data);
  } catch (error) {
    console.log(error);
    debugger;
    throw error;
  }
};

export const resetPassword = async (data, token) => {
  try {
    return MasterService.post(`${AUTH_APPCORE}/resetpassword?token=${token}`, data);
  } catch (error) {
    throw error;
  }
}

export const validateRoute = async (route) => {
  try {
    return MasterService.get(`${AUTH_BASE}/validateroute?route=${route}`);
  } catch (error) {
    throw error;
  }
}

export const generateToken = async () => {
  try {
    return MasterService.post(`${AUTH_BASE}/generatetoken`);
  } catch (error) {
    throw error;
  }
}

export const ssoTokenValidation = async (data) => {
  try {
    return MasterService.post(`${AUTH_APPCORE}/ssologin-user`, data);
  } catch (error) {
    throw error;
  }
};

export const verifyUserByEmail = async (data) => {
  try {
    return MasterService.post(`${AUTH_BASE}/verifyemail`, data);
  } catch (error) {
    throw error;
  }
};